import { render, staticRenderFns } from "./ProductTab.vue?vue&type=template&id=53957c8a&scoped=true&"
import script from "./ProductTab.vue?vue&type=script&lang=js&"
export * from "./ProductTab.vue?vue&type=script&lang=js&"
import style0 from "./ProductTab.vue?vue&type=style&index=0&id=53957c8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53957c8a",
  null
  
)

export default component.exports
import {QForm,QScrollArea,QSelect,QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QScrollArea,QSelect,QInput})
